import { forwardRef, useState } from 'react';
import {
  Check16,
  Email,
  FacebookMulticolor,
  Link16,
  LinkedinMulticolor,
  TelegramMulticolor,
  TwitterXMulticolor,
  WhatsappMulticolor
} from '@elfsight/icons';
import { copyTextToClipboard } from '@elfsight/lib-utils';
import { openWindow } from '@elfsight/widget-utils';
import { useTranslation } from 'react-i18next';
import type { DropdownProps } from '../dropdown';
import { Dropdown, DropdownItem, DropdownSeparator } from '../dropdown';

export type ShareDropdownProps = Omit<DropdownProps, 'children'> & {
  link: string;
};

const copyLinkLabel = 'Copy Link';

export const ShareDropdown = forwardRef<HTMLDivElement, ShareDropdownProps>(
  function ShareDropdown(
    { link, popoutDirection = 'upward', onCloseRequest, ...forwardingProps },
    forwardingRef
  ) {
    const { t } = useTranslation();
    const [linkCopied, setLinkCopied] = useState(false);

    const handleCopy = () => {
      setLinkCopied(true);
      copyTextToClipboard(link);

      setTimeout(() => {
        setLinkCopied(false);
        onCloseRequest();
      }, 1000);
    };

    const handleShare = (shareLink: string) => {
      openWindow(shareLink + link);
      onCloseRequest();
    };

    return (
      <Dropdown
        {...forwardingProps}
        ref={forwardingRef}
        closeOnClick={false}
        iconSize={20}
        popoutDirection={popoutDirection}
        onCloseRequest={onCloseRequest}
      >
        <DropdownItem
          icon={linkCopied ? Check16 : Link16}
          onClick={handleCopy}
          ariaLabel={t(copyLinkLabel)}
        >
          {/* // TODO: Обернуть фразу в lingui макрос после переноса social-feed в WU */}
          {'Link Copied'}
        </DropdownItem>

        <DropdownSeparator />

        {platformsMapping.map(({ label, icon, shareLink }) => (
          <DropdownItem
            key={label}
            icon={icon}
            onClick={() => handleShare(shareLink)}
            ariaLabel={t(label)}
          >
            {t(label)}
          </DropdownItem>
        ))}
      </Dropdown>
    );
  }
);

// TODO: Обернуть лейблы в lingui макросы после переноса social-feed в WU (сделать useGetPlaformsMapping)
const platformsMapping = [
  {
    label: 'Share on Facebook',
    icon: FacebookMulticolor,
    shareLink: 'https://www.facebook.com/sharer/sharer.php?u='
  },
  {
    label: 'Share on WhatsApp',
    icon: WhatsappMulticolor,
    shareLink: 'https://api.whatsapp.com/send?text='
  },
  {
    label: 'Share on Telegram',
    icon: TelegramMulticolor,
    shareLink: 'https://telegram.me/share/url?url='
  },
  {
    label: 'Share via Email',
    icon: Email,
    shareLink: 'mailto:?body='
  },
  {
    label: 'Share on X',
    icon: TwitterXMulticolor,
    shareLink: 'https://twitter.com/intent/tweet?url='
  },
  {
    label: 'Share on LinkedIn',
    icon: LinkedinMulticolor,
    shareLink: 'https://www.linkedin.com/shareArticle?url='
  }
];
